import { render, staticRenderFns } from "./PropertyItemListItem.vue?vue&type=template&id=c70b9054&scoped=true"
import script from "./PropertyItemListItem.vue?vue&type=script&lang=js"
export * from "./PropertyItemListItem.vue?vue&type=script&lang=js"
import style0 from "./PropertyItemListItem.vue?vue&type=style&index=0&id=c70b9054&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70b9054",
  null
  
)

export default component.exports